/* eslint-disable */
import React, { useState, useEffect,  useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Field from './Field';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { createUser, updateUser } from '../../actions/userActions';
import { useSnackbar } from 'react-simple-snackbar';
import * as api from '../../api/index';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddUser = ({ setOpenUser, openUser, currentUser, currentIndex, users,setRows }) => {
  const location = useLocation()
  const formRef = useRef();
  const [userData, setUserData] = useState({ id:0,userName:'', email:'', firstName: '', lastName: '', password:'', isAtive:true, roldId:0 })
  // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => setShowPassword(!showPassword);
  const [user, setUser] = useState(false);

  useEffect(() => {
    if (currentUser) {

      //console.log("currentUser data",currentUser)
      setUserData(currentUser);
      setUserData( {...currentUser, roleId : currentUser?.role?.id, id:currentUser.id} );
      //console.log("user data",userData)
    }else
    {
       setUserData({ id:0,userName:'', email:'', firstName: '', lastName: '', password:'', isAtive:true, roldId:0 });
    }
  }, [currentUser])





  const handleChange =(e)=> {
   
    setUserData( {...userData, [e.target.name] : e.target.value} )  
 }

  const handleSubmitUser = async (e) => {
    e.preventDefault()
    let errorMessage = "";
    if (userData.firstName ==="") errorMessage+="First Name is required."
    if (userData.lastName ==="") errorMessage+="Last Name is required."
    if (userData.email ==="") errorMessage+="Email Name is required."
    if (userData.password ==="") errorMessage+="Password is required."
    if (userData.password !==userData.confirmPassword ) errorMessage+="Password and confirm password should be same."
    if (userData.roldId === "0") errorMessage+="Role is required."
    if (errorMessage.length>0){
          openSnackbar(errorMessage);
      return;
    }
    

    setUserData( {...userData, userName : userData.email} )
    try {

       
        if (parseInt(userData.id)>0) {
        console.log(userData);
        const { data } = await api.updateUser(userData.id, userData);
        users[currentIndex] = userData;
        setRows(users);
        openSnackbar("User updated successfully");
        
        
        } else {
          const { data } = await api.signUp(userData);
          openSnackbar("User added successfully");
          const user = data.data;
          users.push(user);
          //console.log(users);
          //setUsers(users);
        }

    } catch (error) {
      console.log(error)
    }
   
    clear()
    handleClose()
  }

  const clear = () => {
     //setCurrentId(null)
     setUserData({ id:0, userName:'', email:'', firstName: '', lastName: '', password:'', isAtive:true, roldId:0 })
  }

  const handleClose = () => {
    setOpenUser(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
  }


  return (
    <div>
      <form >
        <Dialog
          onClose={(e, reason) => {
            if (reason !== 'backdropClick') {
              handleClose()
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={openUser} fullWidth
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ paddingLeft: '20px', color: 'white' }}>
            {currentUser ? 'Edit User' : 'Add New User'}
          </DialogTitle>
          <DialogContent dividers>

          <Grid container spacing={2}>
            <Field name="firstName" label="First Name" required value={userData.firstName} handleChange={handleChange} autoFocus half />
            <Field name="lastName" label="Last Name"  required value={userData.lastName} handleChange={handleChange} half />
            <Field name="email" label="Email Address" required value={userData.email} handleChange={handleChange} type="email" />
            <Field name="password" label="Password" required value={userData.password} handleChange={handleChange} type={showPassword ? 'text' : 'password'} handleShowPassword={handleShowPassword} />
            <Field name="confirmPassword" label="Repeat Password" required value={userData.confirmPassword} handleChange={handleChange} type="password" /> 
            <Grid item xs={12} sm={6}>
             <Select  onChange={handleChange} required variant="outlined" value={userData.roleId}   name="roleId" style={{width:300}} >
                <MenuItem value="0" >
                  Select Role
                </MenuItem>
                <MenuItem value="1">Admin</MenuItem>
                <MenuItem value="2">Editor</MenuItem>
                <MenuItem value="3">Operator</MenuItem>
              </Select>
              </Grid>

          </Grid>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmitUser} variant="contained" style={{ marginRight: '25px' }} >
              Save User
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
}

export default AddUser